import { TableHeaderCellIcon } from './styles';
import { BiSortAlt2 } from 'react-icons/bi';
import SortingUpIcon from './images/SortingUp.svg?react';
import SortingDownIcon from './images/SortingDown.svg?react';

type TableSortNewType = {
  isAscendingSorting: boolean;
  isDescendingSorting: boolean;
  isUnsorted: boolean;
};

export const TableSortNew = ({ isAscendingSorting, isDescendingSorting, isUnsorted }: TableSortNewType) => {
  return (
    <TableHeaderCellIcon>
      {isUnsorted && <BiSortAlt2 size={16} />}
      {isAscendingSorting && <SortingUpIcon />}
      {isDescendingSorting && <SortingDownIcon />}
    </TableHeaderCellIcon>
  );
};
